"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdown = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var ToggleButton_1 = __importDefault(require("./components/ToggleButton"));
var Menu_1 = __importDefault(require("./components/Menu"));
var Item_1 = __importDefault(require("./components/Item"));
var DropdownContext = react_1.createContext({
    isMenuOpen: false,
    setIsMenuOpen: function () { },
    triggerButtonElement: null,
    setTriggerButtonElement: function () { },
    triggerButtonRef: null,
    setTriggerButtonRef: function () { },
    menuContainerRef: { current: null },
});
DropdownContext.displayName = "DropdownContext";
function useDropdown() {
    return react_1.useContext(DropdownContext);
}
exports.useDropdown = useDropdown;
function Dropdown(_a) {
    var children = _a.children;
    var menuContainerRef = react_1.useRef(null);
    var _b = react_1.useState(null), triggerButtonElement = _b[0], setTriggerButtonElement = _b[1];
    var _c = react_1.useState(false), isMenuOpen = _c[0], setIsMenuOpen = _c[1];
    var _d = react_1.useState(null), triggerButtonRef = _d[0], setTriggerButtonRef = _d[1];
    function handleClickOutsideMenu(event) {
        var isOutsideMenu = menuContainerRef &&
            menuContainerRef.current &&
            !menuContainerRef.current.contains(event.target);
        var isOutsideTriggerButton = triggerButtonElement &&
            !triggerButtonElement.contains(event.target);
        if (isOutsideMenu && isOutsideTriggerButton)
            setIsMenuOpen(false);
    }
    hooks_1.useClickOutsideContainer(menuContainerRef, function (event) {
        event && handleClickOutsideMenu(event);
    });
    return (react_1.default.createElement(DropdownContext.Provider, { value: {
            triggerButtonElement: triggerButtonElement,
            setTriggerButtonElement: setTriggerButtonElement,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            isMenuOpen: isMenuOpen,
            setIsMenuOpen: setIsMenuOpen,
            menuContainerRef: menuContainerRef,
        } }, children));
}
Dropdown.ToggleButton = ToggleButton_1.default;
Dropdown.Menu = Menu_1.default;
Dropdown.Item = Item_1.default;
exports.default = Dropdown;
//# sourceMappingURL=index.js.map